<template>
  <div class="ms-cell-editor text text-overflow">
    <div
      v-show="!isSelected || readOnly"
      :class="{
        'edit-disabled': readOnly,
        'ms-editor-text': editable,
        hasError: errorProvider.isValid,
        'display-error': errorMessage && !isEditor,
        'error-border': errorMessage,
      }"
    >
      <!-- <div class="editor-display" v-if="!isEditor">
        
      </div> -->
      <a v-show="!isEditor" class="editor-click" @click="$emit('editorClick', $event, col, colIndex)">
        <span
          class="editor-display"
          :class="[`text-${col.align || 'left'}`]"
          :title="[
            dataRow[col.dataField]
              ? $ms.format.formatData(dataRow[col.dataField], {
                  formatType: col.formatType,
                })
              : '',
          ]"
          >{{
            dataRow[col.dataField]
              ? $ms.format.formatData(dataRow[col.dataField], {
                  formatType: col.formatType,
                })
              : ''
          }}</span
        >
      </a>

      <ms-input v-if="isEditor" v-model="cellData" :max-length="propsData?.maxLength" v-on="listeners" 
          :preventPaste="allowCopyFromExcel"> </ms-input>

      <div v-show="errorMessage && !isEditor" v-tooltip="errorMessage" class="icon24 error"></div>
    </div>
  </div>
</template>
<script>
import {defineProps, getCurrentInstance, defineEmits, watch, nextTick, defineExpose, inject} from 'vue';
import {useCellEditor} from './CellEditorSetup.js';
export default {
  name: 'MsCellInput',
  props: {
    col: {},
    dataRow: {},
    rowIndex: {
      default: 0,
      type: Number,
    },
    colIndex: {
      default: 0,
      type: Number,
    },
    // Thuộc tính để cấu hình cho phép sửa trên grid hay không
    editable: {
      default: true,
      type: Boolean,
    },
    rowSelected: {
      default: null,
    },

    readOnly: {
      default: false,
      type: Boolean,
    },
    // có cho phép show text validate bên dưới cell k
    isShowText: {
      type: Boolean,
      default: false,
    },
    propsData: {
      type: Object,
      default: () => {},
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['editorClick', 'msKeydown', 'update:modelValue', 'pasteInput'],

  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();

    const isCellEditor = inject('isCellEditor');
    const allowCopyFromExcel = inject('allowCopyFromExcel');

    const {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      getValue,
      clearValidate,
    } = useCellEditor({
      props,
      emit,
    });
    watch(isEditor, newVal => {
      if (!newVal) {
        emit('update:modelValue', cellData.value);
      } else {
        cellData.value = props.dataRow[props.col.dataField];
        nextTick(() => {
          findEditor();
        });
      }
    });
    
    /**
     * Gán giá trị cho cell
     */
    const setValue = value => {
      let me = proxy;

      if (typeof isCellEditor == 'function' && !isCellEditor(props.col, props.dataRow)) {
        return;
      }

      if (me.readOnly) {
        return;
      }
      if (me.propsData?.maxLength && value?.length > me.propsData?.maxLength) {
        value = value.substring(0, proxy.maxLength);
      }
      cellData.value = value;
      emit('update:modelValue', cellData.value);
    };

    return {
      isEditor,
      errorProvider,
      isSelected,
      listeners,
      activeCell,
      inactiveCell,
      cellData,
      findEditor,
      errorMessage,
      validate,
      getValue,
      clearValidate,
      setValue,
      allowCopyFromExcel,
    };
  },
};
</script>
<style lang="scss" scoped>
.mi-icon-error {
  margin-right: 8px;
}
</style>
